/**
 * Represents a JSX Element for a hidden aria description.
 * @returns
 */
export const HiddenAriaDescription = ({ id, message }: HiddenAriaDescriptionPropsType) => {
	return (
		<span id={id} hidden>
			{message}
		</span>
	);
};

export type HiddenAriaDescriptionPropsType = {
	id: string;
	message: string;
};
